import { Injectable } from '@angular/core';
import { INotesComponent, INotesSection, Notes } from '@modeso/types__aumico-lib-annualreport-be';
import { ComponentType } from '@modeso/types__aumico-lib-notes-be';
import { cloneDeep } from 'lodash-es';
import { NotesEmptyLinesRemovalHelper } from './notesEmptyLinesRemoval.helper';

@Injectable({
    providedIn: 'root',
})
export class AccordionCompletenessHelper {
    constructor(private notesEmptyLinesRemovalHelper: NotesEmptyLinesRemovalHelper) { }

    public isAccordionCompleted(accordion: INotesSection, currentLanguage: string): boolean {
        const accordionData: INotesComponent[] = cloneDeep(accordion.data);
        for (const component of accordionData) {
            if (!component.isHidden && this.checkCompletenessOfComponents(component.componentName, component.data, currentLanguage)) {
                return true;
            }
        }

        return false;
    }

    public checkCompletenessOfComponents(
        componentName: ComponentType,
        componentData: Notes,
        currentLanguage: string,
    ): boolean {
        // First check if component has no rows at all
        const isComponentCompletelyEmpty = this.notesEmptyLinesRemovalHelper.isComponentDataEmpty(
            componentName,
            componentData,
            currentLanguage,
        );
        if (isComponentCompletelyEmpty) {
            return false;
        }
        // Then try removing empty lines
        const componentWithRemovedEmptyLines = cloneDeep<Notes>(
            this.notesEmptyLinesRemovalHelper.removeEmptyLinesOfComponents(componentName, componentData),
        );

        // Then check again after removing empty lines
        return !this.notesEmptyLinesRemovalHelper.isComponentDataEmpty(
            componentName,
            componentWithRemovedEmptyLines,
            currentLanguage,
        );
    }
}
